import type { EditorPlugin } from '../../types/aha-editor';
import BlockUtils from '../Blocks/BlockUtils';
import { isKeyHotkey } from 'is-hotkey';
import { ToolIndentCode, ToolOutdentCode } from './tools/ToolIndentCode';

const isTab = isKeyHotkey('tab');
const isShiftTab = isKeyHotkey('shift+tab');

const CodeBlockKeydownHandlerPlugin: EditorPlugin = {
  name: 'Code Block Keydown Handler Plugin',
  handlers: {
    onKeyDown: (event, ahaEditor) => {
      const { editor } = ahaEditor;
      const inCodeBlock = BlockUtils.selectionIsInBlock(editor, 'code');
      if (!inCodeBlock) return false;

      // Outdent code when shift+tab is pressed
      if (isShiftTab(event)) {
        event.preventDefault();
        ToolOutdentCode.action({ editor });
        return true;
      }

      // Indent code when tab is pressed
      if (isTab(event)) {
        event.preventDefault();
        ToolIndentCode.action({ editor });
        return true;
      }

      return false;
    },
  },
};

export default CodeBlockKeydownHandlerPlugin;
